import React from 'react';
import { Alert } from '@groupelacentrale/contact-storybook';
import { PhotoInput } from '../PhotoInput/PhotoInput';
import { PhotoPreview } from '../PhotoPreview/PhotoPreview';
import './PhotoContainer.scss';

interface Props {
  files: (File | string)[];
  urls?: string[];
  errors: string[];
  max: number;
  onAdd: (fileList: FileList) => void | undefined;
  onRemove: (name: string) => void | undefined;
}

export const PhotoContainer: React.FC<Props> = ({ files, errors, max, onAdd, onRemove }) => {
  return (
    <div className="photo-container">
      <ul className="photo-preview-list">
        {files.map(file => (
          <li key={file instanceof File ? file.name : file}>
            <PhotoPreview file={file} onRemove={onRemove} />
          </li>
        ))}
      </ul>
      {errors.length !== 0 && (
        <div className="photo-preview-errors">
          <Alert type="error">
            <ul>
              {errors.map(error => (
                <li key={error}>{error}</li>
              ))}
            </ul>
          </Alert>
        </div>
      )}
      <div className={`photo-input-wrapper ${files.length !== 0 ? 'docked' : ''}`}>
        <PhotoInput max={max} currentNumber={files.length} onAdd={onAdd} />
      </div>
    </div>
  );
};
